import React from "react";
import { withStyles } from "@material-ui/core";
import { BackArrow } from "icons";
import IconComponent from "components/IconComponent";

const styles = () => ({
  root: {
    fontFamily: "Open Sans",
    fontStyle: "normal",
    height: 60,
    padding: "12px 20px",
    borderTop: "1px solid #dadada",
    borderBottom: "1px solid #dadada",
    background: "white",
    display: "flex",
    alignItems: "center",
    fontSize: 24,
    lineHeight: "36px",
  },
  headerText: {
    marginLeft: 16,
  },
});

const Header = ({ classes, setOpenAttendeesList }) => {
  const handleBack = () => {
    setOpenAttendeesList(false);
  };
  return (
    <div className={classes.root}>
      <IconComponent Component={BackArrow} onHoverColor="#26bbed" onClick={handleBack} />
      <div className={classes.headerText}>RSVP List</div>
    </div>
  );
};
export default withStyles(styles)(Header);
